<!-- ADJUSTMENT VALID DETAIL GRID -->
<div>
  <kendo-grid #grid [kendoGridBinding]="gridData" [scrollable]="'true'" [resizable]="true" [sortable]="true"
    [pageable]="true" [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
    [filter]="gridState.filter" id="adjustment-grid" [rowSelected]="isRowSelected" (edit)="editHandler($event)"
    [selectable]="{enabled: true, checkboxOnly: true}" (selectionChange)="onSelectionChange($event)">
    <!-- TOOLBAR TEMPLATE -->
    <ng-template kendoGridToolbarTemplate>
      <div class="row bottom-margin-0">
        <div class="col m8 l8 xl6 margin-5 width-100p">
          <button kendoButton class="btn btn-fullwidth background-red right-margin-5"
            (click)="deleteRecordDialog = true" [disabled]="!enableChildDeleteBtn">Delete PPED Records</button>
        </div>
        <div id="adj-mobile-view-msg">
          <p class="text-red"><span class="k-icon k-i-warning"></span>Add/Edit adjustment will
            not be available on Mobile Devices</p>
        </div>
      </div>
    </ng-template>

    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">Fiscal Year: </span>
              <span> {{ dataItem.fiscalYear }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PPED: </span>
              <span> {{ dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Contribution: </span>
              <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
                {{ dataItem.formatAmount }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">HW: </span>
              <span> {{ dataItem.hoursWorked}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">SH: </span>
              <span> {{ dataItem.standardHours}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PCT: </span>
              <span> {{ dataItem.percentFullTime}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AAComp: </span>
              <span> {{ dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AEComp: </span>
              <span> {{ dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Reason Code: </span>
              <span> {{ dataItem.reasonCodes}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Error: </span>
              <span class="text-red" *ngIf="dataItem.error" title={{dataItem.error}}><span
                  class="k-icon k-i-error text-red"></span></span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Warning: </span>
              <span class="text-red" *ngIf="dataItem.issue" title={{dataItem.issue}}><span
                  class="k-icon k-i-warning text-red"></span></span>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>

    <!-- ADJUSTMENT AND PAYROLL DETAIL VIEW -->
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div class="row bottom-margin-5">
        <div class="col s12 m12 l12 xl12">
          <app-corresponding-view [data]="dataItem"></app-corresponding-view>
        </div>
      </div>
    </ng-template>

    <!-- CHILD CHECK BOX -->
    <kendo-grid-checkbox-column showSelectAll="true" class="chkbox align-center" [width]="40">
      <ng-template kendoGridHeaderTemplate let-idx="rowIndex" let-dataItem *ngIf="gridData && gridData.length > 0">
        <div class="align-center">
          <input class="k-checkbox" type="checkbox" kendoGridSelectAllCheckbox id="selectAllChildCheckboxId"
            [disabled]="isDisabled === true">
          <label class="k-checkbox-label" for="selectAllChildCheckboxId"></label>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
        <div class="align-center">
          <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'childChk'+idx}}"
            [disabled]="isDisabled === true" />
          <label class="k-checkbox-label" for="{{'childChk'+idx}}"></label>
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>

    <!-- EDIT AND DELETE BTNS -->
    <kendo-grid-command-column media="(min-width: 773px)" title="" [width]="60" *ngIf="(operators.Edit)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-center" kendoTooltip>
          <a kendoGridEditCommand id="editBtn" *ngIf="operators.Edit" (click)="dataItem.isClicked=!dataItem.isClicked">
            <span class="k-icon k-i-edit link-icon" *ngIf="!dataItem.isClicked" title="Edit"></span>
            <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
          </a>
        </div>
      </ng-template>
    </kendo-grid-command-column>

    <!-- FISCAL YEAR -->
    <kendo-grid-column media="(min-width: 773px)" field="fiscalYear" title="Fiscal Year" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.fiscalYear}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- PPED -->
    <kendo-grid-column media="(min-width: 773px)" field="payPeriodEndDate" title="PPED" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <a (click)="openRecord(dataItem, true)" class="clone-link">
            {{dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- EMP CONTRIBUTION -->
    <kendo-grid-column media="(min-width: 773px)" field="employeeContribution" title="Contribution" [width]="110"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">
          <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
            {{dataItem.formatAmount}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- HOURS WORKED -->
    <kendo-grid-column media="(min-width: 773px)" field="hoursWorked" title="HW" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- STANDARD HOURS -->
    <kendo-grid-column media="(min-width: 773px)" field="standardHours" title="SH" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- PCT -->
    <kendo-grid-column media="(min-width: 773px)" field="percentFullTime" title="PCT" [width]="60" format="{0:n0}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- AAC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualAnnualCompensation" title="AAComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <!-- AEC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualEarnableCompensation" title="AEComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number">{{dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
      </ng-template>
    </kendo-grid-column>

    <!-- ERROR STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="error" title="Error" [headerStyle]="{'text-align': 'center'}"
      [width]="80" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span class="text-red" *ngIf="dataItem.error" title={{dataItem.error}}><span
              class="k-icon k-i-error text-red"></span></span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- WARNING STATUS -->
    <kendo-grid-column media="(min-width: 773px)" field="warning" title="Warning"
      [headerStyle]="{'text-align': 'center'}" [width]="100" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-center">
          <span class="text-warning" *ngIf="dataItem.issue" title={{dataItem.issue}}><span
              class="k-icon k-i-warning text-warning"></span></span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
  <div *ngIf="isClicked">
    <app-record-detail-view [adjRecordDetail]="adjRecord" (isCancelClicked)="isDialogClosed($event)">
    </app-record-detail-view>
  </div>
</div>

<!-- DELETE CHILD VALID ADJUSTMENT RECORD -->
<kendo-dialog title="Delete Record" *ngIf="deleteRecordDialog" (close)="deleteRecordDialog=false" [minWidth]="250"
  id="delete-adj-dialog" class="app-dialog">
  <div class="deleteAdj">
    <div>{{config.DeleteAdjRecordMsg}}
    </div>
    <ng-template #deleteAdjReport>
      {{config.DeleteLastAdjRecordMsg}}
      <span> Do you want to continue? </span>
    </ng-template>
  </div>
  <kendo-dialog-actions id="delete-adj-btns">
    <button kendoButton class="k-button" id="no-btn" [disabled]="loading" (click)="deleteRecordDialog=false"
      primary="true">No</button>
    <button kendoButton class="k-button" id="yes-btn" [disabled]="loading" (click)="deleteRecord()" primary="true">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
